
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductsGrid extends Serenity.EntityGrid<ProductsRow, any> {
        protected getColumnsKey() { return ProductsColumns.columnsKey; }
        protected getDialogType() { return ProductsDialog; }
        protected getIdProperty() { return ProductsRow.idProperty; }
        protected getInsertPermission() { return ProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductsRow.localTextPrefix; }
        protected getService() { return ProductsService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);

            buttons.push({
                title: 'Assign to Franchisee',
                cssClass: 'edit-button',
                onClick: () => {
                    var SelectedKeys = this.rowSelection.getSelectedKeys();
                    if (SelectedKeys.length == 0) {
                        Q.alert("Please select atleast one Product!");
                        return;
                    }
                    new RioERP.Products.ProductsFranchiseeDialog(this, true, SelectedKeys).loadNewAndOpenDialog();
                },
                separator: true
            });

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: ProductsService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            buttons.push({
                title: 'Import From Excel',
                cssClass: 'export-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new ProductsExcelImportDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                },
                separator: true
            });


            buttons.push({
                title: 'Assign Teacher Share', cssClass: 'add-button',
                onClick: () => {
                    //debugger;
                    // we could use EditItem here too, but for demonstration
                    // purposes we are manually creating dialog this time
                    var SelectedKeys = this.rowSelection.getSelectedKeys();
                    if (SelectedKeys.length == 0) {
                        Q.alert("Please select a record !");
                    } else {
                        //debugger;
                        //var d = new Rio.Products.ProductsFranchiseeDialog();
                        //d.element.on('dialogOpen', () => {
                        //    d.rowids = SelectedKeys;
                        //});
                        //d.dialogOpen();
                        new RioERP.Products.ProductTeacherDialog(this, true, SelectedKeys).loadNewAndOpenDialog()
                        // new Rio.Products.ProductsFranchiseeDialog();
                    }
                },
                separator: true
            });

            buttons.push({
                title: 'InActive Product',
                cssClass: 'delete-button',
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    if (rowKeys.length == 0) {
                        Q.alert("Please select record(s)");
                        return;
                    }
                    else {
                        Q.confirm('Are you sure to InActive?', () => {

                            Q.serviceRequest('/Services/Products/Products/InActiveProduct', rowKeys, (response) => { this.rowSelection.resetCheckedAndRefresh(), this.refresh() });
                        });
                    }
                },
                separator: true
            });

            buttons.push({
                title: 'Download Product Sample',
                cssClass: 'export-xlsx-button',
                onClick: () => {
                    /*  debugger;*/
                    var url = "~/Workspace/Products/ProductsImportSample";
                    /*var url = "~/Uploads/ProductsImportSample.xlsx";*/

                    Q.postToService({ url: Q.resolveUrl(url), request: '', target: '_blank' });
                },
                separator: true
            });

            return buttons;
        }
    }
}